import modeType from './modeType'

const state = {
  syncscroll: true,
  currentMode: modeType.view,
  nightMode: false
}

export default state
